export default __webpack_public_path__ + "static/media/fc6_logo_SCH.5228aac8.png";